module.exports = __webpack_public_path__ + "img/educacao-ensino-medio-cpv.19f49994.png";